import * as v from "valibot";

const succeededApiResponseSchema = v.object({
    objects: v.unknown(),
    result: v.object({
        status: v.literal(true),
        message: v.null_(),
    }),
});

const failedApiResponseSchema = v.object({
    objects: v.null_(),
    result: v.object({
        status: v.literal(false),
        message: v.string(),
    }),
});

const apiResponseSchema = v.union([
    succeededApiResponseSchema,
    failedApiResponseSchema,
]);

export type ApiResponse = v.InferOutput<typeof apiResponseSchema>;

/**
 * APIのレスポンスが正しい形をしているかを確認する。
 * なお、成功時レスポンスのobjectsフィールドの型については別途検証すること。
 *
 * @param json 検証対象のデータ
 */
export const assertApiResponse: (json: unknown) => asserts json is ApiResponse = (json: unknown) => {
    v.parse(apiResponseSchema, json);
};
